import React from 'react';

export default function PhotoVaultBanner({ progress, vaultCount }) {
  if (progress && progress.total > 0) {
    const pct = Math.min(100, Math.round((100 * (progress.done || 0)) / progress.total));
    const label =
      progress.phase === 'listing'
        ? 'Preparando catálogo de fotos…'
        : 'Guardando fotos en la app…';
    return (
      <div className="photo-vault-banner" role="status">
        <strong>{label}</strong>
        <span>
          {progress.done || 0}/{progress.total}
          {vaultCount ? ` · ${vaultCount} en la tablet` : ''}
        </span>
        <div className="photo-vault-bar">
          <i style={{ width: `${pct}%` }} />
        </div>
      </div>
    );
  }

  if (vaultCount > 0) {
    return (
      <div className="photo-vault-ok" role="status">
        {vaultCount} fotos guardadas en la app — disponibles sin internet
      </div>
    );
  }

  return null;
}
